import * as R from 'ramda'
import useSWR from 'swr'

import useAxios from 'hooks/useAxios'

export default function usePlanFeature(feature: string, skip = false): boolean | undefined {
  const { fetch } = useAxios({
    url: 'billing/plans/feature-toggle/',
    method: 'post',
    data: { feature },
    skip: true,
  })

  const { data } = useSWR(
    skip ? null : ['plan-feature', feature],
    () => fetch().then((response) => response.data),
    { revalidateOnFocus: false, shouldRetryOnError: false }
  )

  return R.path(['enabled'], data)
}



// WEBPACK FOOTER //
// ./src/hooks/usePlanFeature/index.ts